import { SHTableCell, SHTableCellProps } from "@components/design-systems";
import { SxProps, Theme, useTheme } from "@mui/material";
import { hexToRGBA } from "@utils";

interface SummaryAnalysisCellProps extends SHTableCellProps {
  children?: React.ReactNode;
  cellColor?: string;
  cellWidth?: string | number;
  isHeaderCell?: boolean;
  additionalStyles?: SxProps<Theme>;
}

export const SummaryAnalysisCell = ({
  children,
  cellWidth,
  cellColor = "transparent",
  isHeaderCell,
  additionalStyles,
  ...others
}: SummaryAnalysisCellProps) => {
  const { palette } = useTheme();
  return (
    <SHTableCell
      sx={{
        height: isHeaderCell ? "140px" : "50px",
        position: "relative",
        width: cellWidth,
        minWidth: cellWidth,
        maxWidth: cellWidth,
        border: `solid 1px ${hexToRGBA(palette.primary[50], 0.3)}`,
        backgroundColor: cellColor,
        padding: "10px 10px !important",
        ...additionalStyles,
      }}
      {...others}
    >
      {children}
    </SHTableCell>
  );
};
